import React, { useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default function PaymentResult({ user, type }) {
  const [status, setStatus] = useState('loading'); // loading | success | fail
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (type === 'fail') { setStatus('fail'); setMessage('결제가 취소되었습니다.'); return; }

    const params = new URLSearchParams(window.location.search);
    const paymentKey = params.get('paymentKey');
    const orderId    = params.get('orderId');
    const amount     = params.get('amount');

    if (!paymentKey || !orderId || !amount) {
      setStatus('fail'); setMessage('잘못된 접근입니다.'); return;
    }

    const run = async () => {
      try {
        const fn = httpsCallable(getFunctions(), 'confirmLifetimePayment');
        await fn({ paymentKey, orderId, amount: Number(amount) });
        setStatus('success');
        setMessage('평생 Pro 이용권이 활성화되었습니다! 🎉');
        setTimeout(() => window.location.href = '/', 2500);
      } catch (e) {
        setStatus('fail');
        setMessage(e.message || '결제 처리 중 오류가 발생했습니다. 고객센터로 문의해주세요.');
      }
    };
    run();
  }, [type, user]);

  const icon  = status === 'loading' ? '⏳' : status === 'success' ? '🎉' : '❌';
  const color = status === 'success' ? '#FF6F0F' : status === 'fail' ? '#52525B' : '#6b7280';

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: '16px',
      background: '#f0f2f5',
    }}>
      <div style={{ fontSize: '3rem' }}>{icon}</div>
      <p style={{ fontSize: '1.1rem', fontWeight: '700', color }}>
        {status === 'loading' ? '결제를 확인하는 중...' : message}
      </p>
      {status === 'success' && (
        <p style={{ fontSize: '0.85rem', color: '#6b7280' }}>잠시 후 앱으로 이동합니다.</p>
      )}
      {status === 'fail' && (
        <button onClick={() => window.location.href = '/'}
          style={{
            padding: '10px 24px', borderRadius: '10px', border: 'none',
            background: '#FF6F0F', color: '#fff', cursor: 'pointer',
            fontWeight: '700', fontSize: '0.9rem',
          }}>
          홈으로 돌아가기
        </button>
      )}
    </div>
  );
}
